import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function atLeastOneDaySelectedValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control && control instanceof FormGroup) {
      const days = control.controls;
      const isAnyDaySelected = Object.values(days).some(
        (dayControl) => dayControl.value === true
      );
      return isAnyDaySelected ? null : { atLeastOneDayRequired: true };
    }
    return null;
  };
}
